/*
	comment: 获取url参数模块 
*/
const loc = window.location;
//search不用每次都取，因为search一改变，页面就会重新刷新
const search = loc.search;
//查询参数正则
//排除?号，避免有多个问题情况出错
const reQueryAll = /([^=&?]+)=([^=&?]*)/g;


//查询指定字段
var query = function(name) {
    //var loc = window.location;
    //search不用每次都取，因为search一改变，页面就会重新刷新
    //var search = loc.search;
    //查询参数正则
    //排除?号，避免有多个问题情况出错
    //var reQueryAll = /([^=&?]+)=([^=&?]*)/g;
    var reQuery, matches, cache;
    if(!search) {
        //返回null,表示不存在搜索字段
        //而不返回''，是为了当存在搜索字段，但没有值的情况混淆
        return null;
    }
    reQuery = new RegExp(name+'=([^=&?]*)', 'g');
    cache = [];
    while(matches = reQuery.exec(search)) {
        cache.push(decodeURIComponent(matches[1]));
    }
    if (cache.length) {
        return cache.length === 1 ? cache[0] : cache;
    }
    return null;
};
//查询所有字段
var queryAll = function() {
    var matches, key, value;
    var params = {};
    //没有的话，浏览器默认字符串为空
    if (!search) {
        //返回空对象，避免外部还要判断是否存在
        return null;
    }
    //exec返回null，表示匹配结束
    while(matches = reQueryAll.exec(search)) {
        key = matches[1];
        value = decodeURIComponent(matches[2]);
        //一个值，第一次进值
        if (!params[key]) {
            params[key] = value;
        }
        //key对应多个值
        else {
            //第二次进值要转为数组
            if (!Array.isArray(params[key])) {
                params[key] = [params[key], value];
            }
            //第n(n>2)次进值
            else {
                params[key].push(value);
            }
        }
    }
    return params;
};
export {
    query,
    queryAll
}



// WEBPACK FOOTER //
// ./src/js/util.urlSearch.js